import * as React from 'react';
import {ClientSummary, Site} from "../api/dtos/dtos";
import FormItem from "antd/lib/form/FormItem";
import * as formUtils from "../utils/form-utils";
import locales from "../locales";
import ClientSelector from "../client-details/ClientSelector";
import ClientSiteSelector from "../client-details/ClientSiteSelector";
import ClientDetailsAlert from "../client-details/ClientDetailsAlert";
import InputFormItem from "../common/form-items/InputFormItem";
import {FormComponentProps} from "antd/lib/form";

const FIELD_CLIENT_SITE = "clientSite";

interface Props extends FormComponentProps {
  createMode: boolean;
  initialClient?: ClientSummary;
  client?: ClientSummary;
  initialSite?: Site;
  site?: Site;
  clientRequired?: boolean;
  onClientChange: (client?: ClientSummary) => void;
  onSiteChange: (site?: Site) => void;
}

export class ClientAndSiteSelector extends React.Component<Props, any> {

  public render(): React.ReactNode {
    const {form, createMode, client, clientRequired, site, initialClient, initialSite, onClientChange, onSiteChange} = this.props;
    return (
      <>
        {createMode && <>
            <FormItem {...formUtils.formItemLayout} label={locales.client_name} required={clientRequired}>
                <ClientSelector
                    editable={initialClient === undefined}
                    client={client}
                    onSelect={onClientChange}
                />
            </FormItem>
          {!initialSite &&
              <FormItem {...formUtils.formItemLayout} label={locales.client_site}>
                  <ClientSiteSelector
                      site={site}
                      client={client}
                      disabled={false}
                      onSiteChange={onSiteChange}
                  />
              </FormItem>
          }
          {initialSite &&
              <InputFormItem
                  fieldId={FIELD_CLIENT_SITE}
                  form={form}
                  label={locales.client_site}
                  initialValue={initialSite.address}
                  required={false}
                  disabled={true}
              />
          }
        </>}
        {!createMode && <>
          {client &&
              <FormItem {...formUtils.formItemLayout} label={locales.client_name}>
                  <ClientDetailsAlert
                      closable={false}
                      client={client}
                  />
              </FormItem>
          }
          {!client &&
              <InputFormItem
                  fieldId={FIELD_CLIENT_SITE}
                  form={form}
                  label={locales.client_name}
                  initialValue={""}
                  required={false}
                  disabled={true}
              />
          }
            <InputFormItem
                fieldId={FIELD_CLIENT_SITE}
                form={form}
                label={locales.client_site}
                initialValue={site?.address}
                required={false}
                disabled={true}
            />
        </>}
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/maintenance/ClientAndSiteSelector.tsx